import { useEffect, useRef, useState } from 'react';

import { useStyles } from './WhatsAppPreview.styles';
import { WhatsAppPreviewProps } from './WhatsAppPreview.types';
import whatsappBackground from './whatsapp_background.png';

export const WhatsAppPreview = ({ items, height = 600, className }: WhatsAppPreviewProps) => {
  const hasButtons = items.some((item) => item.type === 'button');
  const [imageWidth, setImageWidth] = useState(0);
  const imageRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    const handleImageLoad = () => {
      if (imageRef.current) {
        const img = imageRef.current;
        const aspectRatio = img.naturalWidth / img.naturalHeight;
        const actualWidth = height * aspectRatio;
        setImageWidth(actualWidth);
      }
    };

    const img = imageRef.current;
    if (img) {
      if (img.complete) {
        handleImageLoad();
      } else {
        img.addEventListener('load', handleImageLoad);
        return () => img.removeEventListener('load', handleImageLoad);
      }
    }
  }, [height]);

  const classes = useStyles({ hasButtons, height, imageWidth });

  return (
    <div css={classes.root} className={className}>
      <div css={classes.imageContainer}>
        <img ref={imageRef} src={whatsappBackground} alt="WhatsApp background" css={classes.backgroundImage} />
      </div>
      <div css={classes.itemsContainer}>
        {items.map((item, index) => {
          if (item.type === 'message') {
            return (
              <div key={`item-${index}`} css={classes.messageBubble}>
                {item.text}
              </div>
            );
          }

          if (item.type === 'button') {
            return (
              <div key={`item-${index}`} css={classes.button}>
                {item.icon && <div css={classes.buttonIcon}>{item.icon}</div>}
                <div css={classes.buttonText}>{item.text}</div>
              </div>
            );
          }

          return null;
        })}
      </div>
    </div>
  );
};
